import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import pdfIcon from "../../assets/icons/Pdf.svg";
import excel from "../../assets/icons/Excel.svg";
import { formateDateTime } from "../../utils/formattedDateTime";
import ExportTableView from "../pages/User/Report/exports/ExportTableView";
import { getPdfTableHead, mapRowsForExcel } from "./reportExport";
import toast from "react-hot-toast";

const ExportTableData = ({
  reportType,
  type,
  interval,
  selectedDevice,
  handleExportClick,
}) => {
  function exportToExcel(chartData) {
    const chartType = mapRowsForExcel({
      reportType,
      type,
      interval,
      rows: chartData,
    });

    const worksheet = XLSX.utils.json_to_sheet(chartType);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Chart Data");
    return workbook;
  }

  async function handleExcelExport() {
    toast.success("Data will be exported shortly.");
    const getData = await handleExportClick({ limit: -1, page: -1 });
    const workbook = exportToExcel(getData);
    XLSX.writeFile(
      workbook,
      `${selectedDevice}_${formateDateTime(new Date())}.xlsx`
    );
  }
  
  const handlePDFExport = async () => {
    toast.success("Data will be exported shortly.");

    const getData = await handleExportClick({ limit: 500, page: 1 });

    const blb = await pdf(
      <ExportTableView
        currentItems={getData}
        interval={interval}
        type={type}
        reportType={reportType}
        tableHead={getPdfTableHead({ reportType, type, interval })}
      />
    ).toBlob();
    saveAs(blb, `${selectedDevice}_${formateDateTime(new Date())}`);
  };

  return (
    <div className="export-wrap d-flex justify-content-end mb-4">
      <div className="export-btn">
        Export
        <button onClick={() => handleExcelExport()}>
          <img src={excel} alt="excel" />
        </button>
        <button onClick={() => handlePDFExport()}>
          <img src={pdfIcon} alt="excel" />
        </button>
      </div>
    </div>
  );
};
export default ExportTableData;
